<template>
    <div class="application-display-field" v-if="hasValue(fieldName, data[fieldName])">
        <div class="application-display-field__label" v-if="displayLabel">
            {{ $tc(`applicationsFields.${fieldName}`) }}:
        </div>
        <div class="application-display-field__value" v-html="formattedValue(fieldName, data[fieldName])"></div>
    </div>
</template>
<script>
import {store} from "atom";
const {createNamespacedHelpers} = store;
const {mapGetters} = createNamespacedHelpers("arcman");
import {APPLICATIONS_LOCALIZED_FIELDS, APPLICATIONS_EMPTY_ARRAY_DISPLAYED_FIELDS} from "../constants";
export default {
    name: "application-display-field",
    props: {
        data: {type: Object, required: true},
        displayLabel: {type: Boolean, default: true},
        field: {type: [Object, String], required: true},
    },
    computed: {
        ...mapGetters(["currentLocale"]),
        fieldName() {
            return typeof this.field === "object" ? this.field.name : this.field;
        },
    },
    methods: {
        formattedValue(fieldName, fieldValue) {
            // TODO to be replaced with a filed type -rendering component mapping
            if (Array.isArray(fieldValue)) {
                let transformedArray = fieldValue.map(element => {
                    if (typeof element === "object" && APPLICATIONS_LOCALIZED_FIELDS.has(fieldName)) {
                        return element[this.currentLocale];
                    } else if (typeof element === "object") {
                        return JSON.stringify(element, undefined, 4);
                    } else {
                        return this.$tph(`${fieldName}.${element}`, element);
                    }
                });
                return transformedArray.length > 0
                    ? transformedArray.join(", ")
                    : this.$tph(`${fieldName}.none`, "none");
            } else if (typeof fieldValue === "object" && APPLICATIONS_LOCALIZED_FIELDS.has(fieldName)) {
                return fieldValue[this.currentLocale];
            } else if (typeof fieldValue === "object") {
                let entries = [];
                for (let [key, value] of Object.entries(fieldValue)) {
                    if (value) {
                        entries.push(this.$tph(`${fieldName}.${key}`, key));
                    }
                }
                return entries.join(", ");
            } else {
                return fieldValue;
            }
        },
        hasValue(fieldName, fieldValue) {
            if (
                Array.isArray(fieldValue) &&
                (fieldValue.length > 0 || APPLICATIONS_EMPTY_ARRAY_DISPLAYED_FIELDS.has(fieldName))
            ) {
                return true;
            } else if (typeof fieldValue === "object" && Object.entries(fieldValue).length > 0) {
                return true;
            } else if (typeof fieldValue === "object" && Object.entries(fieldValue).length === 0) {
                return false;
            } else if (typeof fieldValue !== "undefined" && fieldValue !== "") {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.application-display-field::v-deep {
    .application-display-field__object-etnry {
        @apply m-0 pb-1;
    }

    .application-display-field__object-key {
        @apply mr-2;
    }
}
</style>
